const Host = () => import('../views/pages/host/host.vue')
const HostLogin = () => import('../views/pages/host/host-login/host-login.vue') // 展商登录页
const HostLoginAlogin = () =>
  import('../views/pages/host/host-login/components/alogin.vue') // 密码登录
const HostLayout = () =>
  import('../views/pages/host/host-layout/host-layout.vue') // 展商布局页
const HostHome = () => import('../views/pages/host/host-home/host-home.vue') // 展商注册页

// 项目管理
const HostProject = () =>
  import('../views/pages/host/host-project/host-project.vue') // 项目管理

// 网站设置
const webSet = () => import('../views/pages/host/web-set/web-set.vue') // 网站设置
const webBanner = () =>
  import('../views/pages/host/web-set/subpages/host-web-ad') // 网站设置-广告管理
const webMarathon = () =>
  import('../views/pages/host/web-set/subpages/host-web-marathon') // 网站设置-活动信息
const webEntrance = () =>
  import('../views/pages/host/web-set/subpages/host-web-entrance') // 网站设置-快捷入口
const webHotPro = () =>
  import('../views/pages/host/web-set/web-hot-pro/web-hot-pro') // 网站设置-热搜产品
const webService = () =>
  import('../views/pages/host/web-set/web-set-service/web-set-service') // 网站设置-客服管理
const webPlan = () =>
  import('../views/pages/host/web-set/web-set-plan/web-set-plan') // 网站设置-展会计划
const email = () =>
  import('../views/pages/host/web-set/web-set-email/web-set-email') // 网站设置-邮箱设置
const phone = () =>
  import('../views/pages/host/web-set/web-set-phone/web-set-phone') // 网站设置-邮箱设置
const enterprise = () =>
  import('../views/pages/host/web-set/web-set-enterprise/web-set-enterprise') // 网站设置-企业查询配置

// 展会设置
const set = () => import('../views/pages/host/set/set.vue') // 展会设置
const HostSet = () => import('../views/pages/host/set/host-set/host-set.vue') // 展会设置
const HostSetClassify = () =>
  import('../views/pages/host/set/host-set-classify/host-set-classify.vue') // 展会设置-供需类别
const HostSetProject = () =>
  import('../views/pages/host/set/host-set-project/host-set-projectset.vue') // 展会设置-供需类别
const HostSetPlan = () =>
  import('../views/pages/host/set/host-set-plan/host-set-plan.vue') // 展会设置-展会计划
const HostSetNews = () =>
  import('../views/pages/host/set/host-set-news/host-set-news.vue') // 展会设置-行业动态
const HostSetAddNews = () =>
  import('../views/pages/host/set/host-set-news/news-add.vue') // 展会设置-添加动态
const HostSetEditNews = () =>
  import('../views/pages/host/set/host-set-news/news-edit.vue') // 展会设置-编辑动态

const HostSetExNews = () =>
  import('../views/pages/host/set/host-set-Exnews/host-set-Exnews.vue') // 展会设置-展商动态
const HostSetAddExNews = () =>
  import('../views/pages/host/set/host-set-Exnews/Exnews-add.vue') // 展会设置-添加动态
const HostSetEditExNews = () =>
  import('../views/pages/host/set/host-set-Exnews/Exnews-edit.vue') // 展会设置-编辑动态
const HostSetMeeting = () =>
  import('../views/pages/host/set/host-set-meeting/host-set-meeting.vue') // 展会设置-会议管理
const HostSetExServices = () =>
  import('../views/pages/host/host-common/subpages/host-common-service.vue') // 展会设置-增值服务
const HostSearch = () =>
  import('../views/pages/host/host-search/host-search.vue') //搜索关键字
const HostStatistics = () =>
  import('../views/pages/host/host-Statistics-talk/index.vue') //洽谈统计
const HostChannel = () => import('../views/pages/host/host-channel/index.vue') //渠道统计
const HostStatisticalManage = () =>
  import('../views/pages/host/host-statisticalManage/index.vue') //统计管理

const HostOperationLog = () =>
  import('../views/pages/host/host-operationLog/host-operationLog.vue') //统计管理
const HostxinPinHui = () =>
  import('../views/pages/host/host-xinPinHui/index.vue') //新品荟统计
const HostZhenPinHui = () =>
  import('../views/pages/host/host-zhenPinHui/index.vue') //臻品荟统计
const HostZhenXinDetail = () =>
  import('../views/pages/host/host-zhenXinDetail/index.vue') //xinzhen详情
const HostInvite = () => import('../views/pages/host/host-invite/index.vue') //邀请函统计
const HostexportTalk = () =>
  import('../views/pages/host/host-Statistics-talk/export-talk.vue') //导出洽谈全部数量
const HostexportTalkCategory = () =>
  import('../views/pages/host/host-Statistics-talk/export-talk-category.vue') //导出洽谈全部类别
const HostexportTalkDetails = () =>
  import('../views/pages/host/host-Statistics-talk/export-talk-details.vue') //导出洽谈全部类别
// 管理

// 审核
const HostAudit = () => import('../views/pages/host/host-audit/host-audit.vue') // 展商管理
const HostAuditList = () =>
  import('../views/pages/host/host-audit/host-audit-list/host-audit-list.vue')
const HostAuditInfo = () =>
  import('../views/pages/host/host-audit/host-audit-info/host-audit-info.vue')
const HostAuditLive = () =>
  import('../views/pages/host/host-audit/host-audit-live/host-audit-live.vue')
const HostNewsAudit = () =>
  import('../views/pages/host/host-audit/host-news-audit/host-news-audit.vue') // 动态审核
const HostActivityAudit = () =>
  import('../views/pages/host/host-audit/host-news-activity/host-news-activity.vue') // 活动审核
const hostAuditScan = () =>
  import('../views/pages/host/host-audit/host-audit-scan/host-audit-scan.vue') // 活动审核

// 管理-展商
const HostEx = () => import('../views/pages/host/host-ex/host-ex.vue') // 展商管理
const HostExList = () =>
  import('../views/pages/host/host-ex/host-ex-list/host-ex-list.vue') // 展商管理-展商列表
const HostExCertApplyManage = () =>
    import('../views/pages/host/host-ex/host-ex-list/host-ex-certApplyManage.vue') // 展商管理-展商证件管理

const HostExCertApplyManageExport = () =>
    import('../views/pages/host/host-ex/host-ex-list/host-ex-certApplyManage-export.vue') // 展商管理-展商证件管理-导出


const HostExListAdd = () =>
  import('../views/pages/host/host-ex/host-ex-list/subpages/ex-add.vue') // 展商管理-展商列表-添加
const HostExListEdit = () =>
  import('../views/pages/host/host-ex/host-ex-list/subpages/ex-edit.vue') // 展商管理-展商列表-编辑

const HostExProList = () =>
  import('../views/pages/host/host-ex/host-ex-list/subpages/ex-prolist/ex-prolist.vue') // 展商管理-展商-产品列表
const HostExportInfo = () =>
  import('../views/pages/host/host-ex/host-export-info/host-export-info.vue')
const HostExAct = () =>
  import('../views/pages/host/host-ex/host-ex-list/subpages/ex-act/ex-act.vue') // 展商管理-展商-活动列表
const HostExProEdit = () =>
  import('../views/pages/host/host-ex/host-ex-list/subpages/ex-prolist/subpages/exhibition-product-edit/exhibition-product-edit.vue') // 展商管理-展商-编辑
const HostExProAdd = () =>
  import('../views/pages/host/host-ex/host-ex-list/subpages/ex-prolist/subpages/exhibition-product-add/exhibition-product-add.vue') // 展商管理-展商-添加
const HostExActAdd = () =>
  import('../views/pages/host/host-ex/host-ex-list/subpages/ex-act/subpages/exhibition-act-add/exhibition-act-add.vue') // 展商管理-活动-添加
const HostExActEdit = () =>
  import('../views/pages/host/host-ex/host-ex-list/subpages/ex-act/subpages/exhibition-act-edit/exhibition-act-edit.vue') // 展商管理-活动-编辑
const HostUser = () =>
  import('../views/pages/host/host-ex/host-ex-user/host-ex-user.vue') // 用户管理

const ManageList = () =>
  import('../views/pages/host/host-ex/host-ex-manage/host-ex-manage.vue') // 展商管理-展商列表
const HostUserPro = () =>
  import('../views/pages/host/host-ex/host-ex-user/host-ex-user-export.vue') // 用户管理
const HostApplyEx = () =>
  import('../views/pages/host/host-ex/host-ex-applyEx/host-ex-applyEx.vue') // 参展申请管理
const HostCert = () => import('../views/pages/host/host-cert/host-cert.vue') // 参展申请管理
const HostPavilion = () =>
  import('../views/pages/host/host-ex/host-ex-pavilion/index.vue') //展团报名列表
// 管理-活动
const HostAct = () =>
  import('../views/pages/host/host-activity/host-activity.vue') // 展商活动
const HostActHome = () =>
  import('../views/pages/host/host-activity/subpages/host-activity-home.vue') // 展会活动-活动列表
const HostActAdd = () =>
  import('../views/pages/host/host-activity/subpages/host-activity-add.vue') // 展会活动-添加
const HostActEdit = () =>
  import('../views/pages/host/host-activity/subpages/host-activity-edit.vue') // 展会活动-编辑
const HostActLive = () =>
  import('../views/pages/host/host-activity/subpages/host-activity-live.vue') // 展会活动-编辑
const HostActExport = () =>
  import('../views/pages/host/host-activity/subpages/host-activity-export') // 展会活动-导出

// 管理-产品
const HostPro = () =>
  import('../views/pages/host/host-product/host-product.vue') // 展商活动
const HostProHome = () =>
  import('../views/pages/host/host-product/subpages/host-product-home.vue') // 展会活动-活动列表
const HostProductEdit = () =>
  import('../views/pages/host/host-product/subpages/host-product-edit.vue') // 展会活动-活动列表
const HostProductExport = () =>
  import('../views/pages/host/host-product/subpages/host-product-export.vue') // 展会活动-活动列表
const HostProductCheck = () =>
  import('../views/pages/host/host-product/subpages/host-product-check.vue') // 展会活动-活动列表
// 管理-车证
const HostCarManage = () =>
  import('../views/pages/host/host-carmanage/host-carmanage.vue')
const HostCarManageHome = () =>
  import('../views/pages/host/host-carmanage/subpages/host-carmanage-home.vue')
//展位导出
const HostexInformation = () =>
  import('../views/pages/host/host-Information/exInformation.vue')
const HostexInformationHome = () =>
  import('../views/pages/host/host-Information/subpages/host-exInformation.vue') // 信息导出
// 供需
const HostSupply = () =>
  import('../views/pages/host/host-supply/host-supply.vue') // 供需审核
const HostSupplyCompany = () =>
  import('../views/pages/host/host-supply/host-supply-company/host-supply-company.vue') // 供需审核-企业供需审核
const HostSupplyUser = () =>
  import('../views/pages/host/host-supply/host-supply-user/host-supply-user.vue') // 供需审核-用户供需审核
const HostSupplyBuySupply = () =>
  import('../views/pages/host/host-supply/host-supply-buySupply/host-supply-buySupply.vue') // 供需审核-采买供需

// 供需信息 旧
const HostSupplyInfo = () =>
  import('../views/pages/host/host-supply-info/host-supply-info.vue') // 供需信息审核
const HostSupplyCompanyInfo = () =>
  import('../views/pages/host/host-supply-info/host-supply-company-info/host-supply-company-info.vue') // 供需信息审核-企业供需信息审核
const HostSupplyUserInfo = () =>
  import('../views/pages/host/host-supply-info/host-supply-user-info/host-supply-user-info.vue') // 供需信息审核-用户供需信息审核
const HostSupplyTask = () =>
  import('../views/pages/host/host-supply-info/host-supply-task/host-supply-task.vue') // 供需信息-导出任务
const HostBusinessOpportunity = () =>
  import('../views/pages/host/host-supply-info/host-business-opportunity/host-business-opportunity.vue') // 供需信息-商机供需
const HostBusinessOpportunityDetail = () =>
  import('../views/pages/host/host-supply-info/host-business-opportunity/host-business-opportunity-detail.vue') // 供需信息-商机供需

// 供需信息 新
const HostSupplyCompanyInfoNew = () =>
  import('../views/pages/host/host-supply-info/host-supply-company-info/host-supply-company-info-new.vue') // 供需信息审核-企业供需信息审核
const HostSupplyUserInfoNew = () =>
  import('../views/pages/host/host-supply-info/host-supply-user-info/host-supply-user-info-new.vue') // 供需信息审核-用户供需信息审核
const HostSupplyTaskNew = () =>
  import('../views/pages/host/host-supply-info/host-supply-task/host-supply-task-new.vue') // 供需信息-导出任务
const HostBusinessOpportunityNew = () =>
  import('../views/pages/host/host-supply-info/host-business-opportunity/host-business-opportunity-new.vue') // 供需信息-商机供需
const HostBusinessOpportunityDetailNew = () =>
  import('../views/pages/host/host-supply-info/host-business-opportunity/host-business-opportunity-detail-new.vue') // 供需信息-商机供需

// 通用
const HostCommon = () =>
  import('../views/pages/host/host-common/host-common.vue') // 通用设置
const HostCommonFunction = () =>
  import('../views/pages/host/host-common/subpages/host-common-function.vue') // 通用-功能管理
const ManageCommon = () =>
  import('../views/pages/host/host-common/subpages/host-common-manage.vue') // 通用-功能管理
const HostCommonAd = () =>
  import('../views/pages/host/host-common/subpages/host-common-ad.vue') // 通用-广告管理
const HostCommonBarcode = () =>
  import('../views/pages/host/host-common/subpages/host-common-barcode.vue') // 通用-条码规则
const HostCommonPoster = () =>
  import('../views/pages/host/host-common/subpages/host-common-poster.vue') // 通用-海报分享模板
const HostCommonPosterAdd = () =>
  import('../views/pages/host/host-common/subpages/host-common-posterAdd.vue') // 通用-添加海报分享模板
const HostCommonPosterEdit = () =>
  import('../views/pages/host/host-common/subpages/host-common-posterEdit.vue') // 通用-编辑海报分享模板
const HostCommonText = () =>
  import('../views/pages/host/host-common/subpages/host-common-text.vue') // 通用-文字分享模板
const HostCommonQuestion = () =>
  import('../views/pages/host/host-common/subpages/host-common-question.vue') // 通用-问券调查
const HostCommonDown = () =>
  import('../views/pages/host/host-common/subpages/host-common-down.vue') // 通用-下载管理
const HostCommonLabel = () =>
  import('../views/pages/host/host-common/subpages/host-common-label.vue') // 通用-下载管理
const HostCommonOpen = () =>
  import('../views/pages/host/host-common/subpages/host-common-open.vue') // 通用-开放设置
const HostCommonGame = () =>
  import('../views/pages/host/host-common/subpages/host-common-game.vue') // 通用-开放设置
const HostCommonRegion = () =>
  import('../views/pages/host/host-common/subpages/host-common-region.vue') // 通用-下载管理
const HostCommonCountry = () =>
  import('../views/pages/host/host-common/subpages/host-common-country.vue') // 通用-国家设置
const HostCommonCity = () =>
  import('../views/pages/host/host-common/subpages/host-common-city.vue') // 通用-省市设置
const HostCommonDepartment = () =>
  import('../views/pages/host/host-common/subpages/host-common-department.vue') // 通用-部门设置
const HostCommonBanner = () =>
  import('../views/pages/host/host-common/subpages/host-common-banner.vue') // 通用-部门设置
const HostCommonMessage = () =>
  import('../views/pages/host/host-common/subpages/host-common-message.vue') // 通用-短信模板
const HostCommonMini = () =>
  import('../views/pages/host/host-common/subpages/host-common-mini.vue') // 通用-小程序设置
const HostMobileAll = () => import('../views/pages/host/mobile-all/index.vue')
//展位预定信息

const hostRouter = [
  {
    path: '/host',
    redirect: '/host/index/home',
    name: 'host',
    component: Host,
    children: [
      {
        path: 'index',
        name: 'HostLayout',
        component: HostLayout,
        children: [
          { path: 'home', name: 'home', component: HostHome },
          {
            path: 'set',
            redirect: '/host/index/set/base',
            name: 'set',
            component: set,
            children: [
              { path: 'base', name: 'base', component: HostSet },
              {
                path: 'classify',
                name: 'classify',
                component: HostSetClassify
              },
              { path: 'project', name: 'project', component: HostSetProject },
              { path: 'plan', name: 'plan', component: HostSetPlan },
              { path: 'news', name: 'news', component: HostSetNews },
              { path: 'newsadd', name: 'newsadd', component: HostSetAddNews },
              {
                path: 'newsedit',
                name: 'newsedit',
                component: HostSetEditNews
              },
              { path: 'Exnews', name: 'Exnews', component: HostSetExNews },
              {
                path: 'Exnewsadd',
                name: 'Exnewsadd',
                component: HostSetAddExNews
              },
              {
                path: 'Exnewsedit',
                name: 'Exnewsedit',
                component: HostSetEditExNews
              },
              {
                path: 'ExServices',
                name: 'ExServices',
                component: HostSetExServices
              },
              { path: 'Meeting', name: 'Meeting', component: HostSetMeeting },
              { path: 'Search', name: 'Search', component: HostSearch },
              {
                path: 'Statistics',
                name: 'Statistics',
                component: HostStatistics
              },
              { path: 'Channel', name: ' Channel', component: HostChannel },
              {
                path: 'statisticalManage',
                name: ' statisticalManage',
                component: HostStatisticalManage
              },
              {
                path: 'hostOperationLog',
                name: ' hostOperationLog',
                component: HostOperationLog
              },
              {
                path: 'xinPinHui',
                name: ' xinPinHui',
                component: HostxinPinHui
              },
              {
                path: 'zhenPinHui',
                name: ' zhenPinHui',
                component: HostZhenPinHui
              },
              {
                path: 'zhenXinDetail',
                name: ' zhenXinDetail',
                component: HostZhenXinDetail
              },
              { path: 'invite', name: ' invite', component: HostInvite },
              {
                path: 'export-talk',
                name: ' export-talk',
                component: HostexportTalk
              },
              {
                path: 'export-talk-category',
                name: ' export-talk-category',
                component: HostexportTalkCategory
              },
              {
                path: 'export-talk-details',
                name: ' export-talk-details',
                component: HostexportTalkDetails
              }
            ]
          },
          {
            path: 'webSet',
            redirect: '/host/index/webSet/webBanner',
            name: 'webSet',
            component: webSet,
            children: [
              { path: 'webBanner', name: 'webBanner', component: webBanner },
              {
                path: 'webMarathon',
                name: 'webMarathon',
                component: webMarathon
              },
              {
                path: 'web-entrance',
                name: 'web-entrance',
                component: webEntrance
              },
              { path: 'web-hotpro', name: 'web-hotpro', component: webHotPro },
              {
                path: 'web-service',
                name: 'web-service',
                component: webService
              },
              { path: 'web-plan', name: 'web-plan', component: webPlan },
              { path: 'web-email', name: 'web-email', component: email },
              { path: 'web-phone', name: 'web-phone', component: phone },
              { path: 'web-enterprise', name: 'web-enterprise', component: enterprise },
            ]
          },
          {
            path: 'supply',
            redirect: '/host/index/supply/company',
            name: 'supply',
            component: HostSupply,
            children: [
              {
                path: 'company',
                name: 'company',
                component: HostSupplyCompany
              },
              { path: 'user', name: 'user', component: HostSupplyUser },
              {
                path: 'buySupply',
                name: 'buySupply',
                component: HostSupplyBuySupply
              }
            ]
          },
          {
            path: 'supply-info',
            redirect: '/host/index/supply-info/company',
            name: 'supply',
            component: HostSupplyInfo,
            children: [
              {
                path: 'company',
                name: 'company',
                component: HostSupplyCompanyInfo
              },
              { path: 'user', name: 'user', component: HostSupplyUserInfo },
              {
                path: 'supply-export',
                name: 'supply-export',
                component: HostSupplyTask
              },
              {
                path: 'business-opportunity',
                name: 'business-opportunity',
                component: HostBusinessOpportunity
              },
              {
                path: 'business-opportunity-detail',
                name: 'business-opportunity-detail',
                component: HostBusinessOpportunityDetail
              },

              {
                path: 'company-new',
                name: 'company-new',
                component: HostSupplyCompanyInfoNew
              },
              {
                path: 'user-new',
                name: 'user-new',
                component: HostSupplyUserInfoNew
              },
              {
                path: 'supply-export-new',
                name: 'supply-export-new',
                component: HostSupplyTaskNew
              },
              {
                path: 'business-opportunity-new',
                name: 'business-opportunity-new',
                component: HostBusinessOpportunityNew
              },
              {
                path: 'business-opportunity-detail-new',
                name: 'business-opportunity-detail-new',
                component: HostBusinessOpportunityDetailNew
              }
            ]
          },
          {
            path: 'ex',
            redirect: '/host/index/ex/list',
            name: 'supply',
            component: HostEx,
            children: [
              { path: 'list', name: 'list', component: HostExList },
                { path: 'certApplyManage', name: 'certApplyManage', component: HostExCertApplyManage },
                { path: 'certApplyManageExport', name: 'certApplyManageExport', component: HostExCertApplyManageExport },
              { path: 'addEx', name: 'addEx', component: HostExListAdd },
              { path: 'editEx', name: 'editEx', component: HostExListEdit },
              { path: 'manage', name: 'manage', component: ManageList },
              { path: 'proList', name: 'proList', component: HostExProList },
              { path: 'act', name: 'act', component: HostExAct },
              { path: 'pro-edit', name: 'pro-edit', component: HostExProEdit },
              { path: 'pro-add', name: 'pro-add', component: HostExProAdd },
              { path: 'act-add', name: 'act-add', component: HostExActAdd },
              { path: 'act-edit', name: 'act-edit', component: HostExActEdit },
              { path: 'user', name: 'user', component: HostUser },
              { path: 'export', name: 'export', component: HostUserPro },
              { path: 'applyEx', name: 'applyEx', component: HostApplyEx },
              { path: 'cert', name: 'cert', component: HostCert },
              { path: 'pavilion', name: 'pavilion', component: HostPavilion },
              {
                path: 'export-info',
                name: 'export-info',
                component: HostExportInfo
              }
            ]
          },
          {
            path: 'audit',
            redirect: '/host/index/audit/list',
            name: 'supply',
            component: HostAudit,
            children: [
              { path: 'list', name: 'list', component: HostAuditList },
              { path: 'info', name: 'info', component: HostAuditInfo },
              { path: 'live', name: 'info', component: HostAuditLive },
              { path: 'news', name: 'news', component: HostNewsAudit },
              {
                path: 'activity',
                name: 'activity',
                component: HostActivityAudit
              },
              { path: 'scan', name: 'activity', component: hostAuditScan }
            ]
          },
          {
            path: 'act',
            redirect: '/host/index/act/act-home',
            name: 'act',
            component: HostAct,
            children: [
              { path: 'act-home', name: 'act-home', component: HostActHome },
              { path: 'act-add', name: 'act-add', component: HostActAdd },
              { path: 'act-edit', name: 'act-edit', component: HostActEdit },
              { path: 'act-live', name: 'act-live', component: HostActLive },
              {
                path: 'act-export',
                name: 'act-export',
                component: HostActExport
              }
            ]
          },
          {
            path: 'pro',
            redirect: '/host/index/pro/pro-home',
            name: 'pro',
            component: HostPro,
            children: [
              { path: 'pro-home', name: 'pro-home', component: HostProHome },
              {
                path: 'pro-edit',
                name: 'pro-edit',
                component: HostProductEdit
              },
              {
                path: 'pro-export',
                name: 'pro-export',
                component: HostProductExport
              },
              {
                path: 'id-check',
                name: 'id-check',
                component: HostProductCheck
              }
            ]
          },
          {
            path: 'common',
            name: 'common',
            component: HostCommon,
            children: [
              {
                path: 'common-function',
                name: 'common-function',
                component: HostCommonFunction
              },
              {
                path: 'common-manage',
                name: 'common-manage',
                component: ManageCommon
              },
              { path: 'common-ad', name: 'common-ad', component: HostCommonAd },
              {
                path: 'common-barcode',
                name: 'common-barcode',
                component: HostCommonBarcode
              },
              {
                path: 'common-poster',
                name: 'common-poster',
                component: HostCommonPoster
              },
              {
                path: 'common-poster-add',
                name: 'common-poster-add',
                component: HostCommonPosterAdd
              },
              {
                path: 'common-poster-edit',
                name: 'common-poster-edit',
                component: HostCommonPosterEdit
              },
              {
                path: 'common-text',
                name: 'common-text',
                component: HostCommonText
              },
              {
                path: 'common-question',
                name: 'common-question',
                component: HostCommonQuestion
              },
              {
                path: 'common-down',
                name: 'common-down',
                component: HostCommonDown
              },
              {
                path: 'common-label',
                name: 'common-label',
                component: HostCommonLabel
              },
              {
                path: 'common-open',
                name: 'common-open',
                component: HostCommonOpen
              },
              {
                path: 'common-game',
                name: 'common-game',
                component: HostCommonGame
              },
              {
                path: 'common-region',
                name: 'common-region',
                component: HostCommonRegion
              },
              {
                path: 'common-country',
                name: 'common-country',
                component: HostCommonCountry
              },
              {
                path: 'common-city',
                name: 'common-city',
                component: HostCommonCity
              },
              {
                path: 'common-department',
                name: 'common-department',
                component: HostCommonDepartment
              },
              {
                path: 'common-banner',
                name: 'common-banner',
                component: HostCommonBanner
              },
              {
                path: 'common-message',
                name: 'common-message',
                component: HostCommonMessage
              },
              {
                path: 'common-mini',
                name: 'common-mini',
                component: HostCommonMini
              }
            ]
          },
          {
            path: 'carmanage',
            redirect: '/host/index/carmanage/carmanage-home',
            name: 'carmanage',
            component: HostCarManage,
            children: [
              {
                path: 'carmanage-home',
                name: 'carmanage-home',
                component: HostCarManageHome
              }
            ]
          },
          {
            path: 'exInformation',
            redirect: '/host/index/exInformation/exInformation-home',
            name: 'exInformation-home',
            component: HostexInformation,
            children: [
              {
                path: 'exInformation-home',
                name: 'exInformation-home',
                component: HostexInformationHome
              }
            ]
          }
        ]
      },
      {
        path: 'project',
        name: 'host-project',
        component: HostProject
      },
      {
        path: 'login',
        redirect: '/host/login/alogin',
        name: 'host-register',
        component: HostLogin,
        meta: { requireAuth: false },
        children: [
          {
            path: 'alogin',
            name: 'alogin',
            component: HostLoginAlogin,
            meta: { requireAuth: false }
          }
        ]
      },
      {
        path: 'mobile-all',
        name: 'host-mopbile-all',
        component: HostMobileAll,
        meta: { requireAuth: false }
      }
    ]
  }
]

export { hostRouter }
